import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface dietType {
    dietTypeEmoji: any;
    dietTypeName: any;
    id: number;
    cuisineTypeName: any;
    imageUrl: any;
    isActive: boolean
}

interface dietState {
    data: dietType[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const MASTERURL = import.meta.env.VITE_API_COOK_URL;

interface ApiResponse {
    data: dietType[];
}

export const fetchdietType = createAsyncThunk<dietType[], void, { rejectValue: string }>(
    'dietType/fetchdietType',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<ApiResponse>('/get_all_diet_type', PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const createdietType: any = createAsyncThunk(
    'dietType/createdietType', async (params: any, thunkAPI) => {
        console.log(params)
        try {
            const response = await apiService.post('create_diet_type', params, PORT, MASTERURL);
            return response
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const updatedietType: any = createAsyncThunk(
    'dietType/updatedietType',
    async (params: any, thunkAPI) => {
        try {
            const response = await apiService.put('update_diet_type', params, PORT, MASTERURL);
            return response
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const softDeleteDietType: any = createAsyncThunk<
    number,                 // ✅ return type: deleted id
    number         // ✅ argument type: cuisine id
>(
    "dietType/deleteDietType",
    async (id,) => {
        try {
            const response = await apiService.patch(
                `soft_delete_diet_type?id=${id}`,
                {},
                PORT,
                MASTERURL
            );
            return response


        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting cuisine type"
            );
        }
    }
);

export const dietSlice = createSlice({
    name: 'dietType',
    initialState: {
        data: [] as dietType[],
        loading: false,
        error: null,
    } as dietState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchdietType.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchdietType.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchdietType.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createdietType.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createdietType.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(createdietType.rejected, (state, action: PayloadAction<string>) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updatedietType.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updatedietType.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                const updatedTable = action.payload;
            })
            .addCase(updatedietType.rejected, (state, action: PayloadAction<string>) => {
                state.loading = false;
                state.error = action.payload;
            })

    },
});

export default dietSlice.reducer;